const GRAPH_VALUES = {
  max: 'Maximum',
  avg: 'Average',
};

export default GRAPH_VALUES;
